import Quill from 'quill';

const Embed = Quill.import('blots/embed');

export default class Mention extends Embed {
  static blotName = 'mention';
  static className = 'ql-mention';
  static tagName = 'EM';

  static create (data) {
    const node = super.create(data.value);
    node.setAttribute('data-value', data.value);
    node.setAttribute('data-id', data.id);

    const denotationChar = document.createElement('span');
    denotationChar.className = 'ql-mention-denotation-char';
    denotationChar.innerHTML = data.denotationChar;
    node.appendChild(denotationChar);

    node.innerHTML += data.value;
    return node;
  }

  static value (domNode) {
    const value = domNode.getAttribute('data-value');
    const id = domNode.getAttribute('data-id');
    return {
      value,
      id
    };
  }

  // html () {
  //   const value = this.value();
  //   console.log('html', value);
  //   const { formula } = this.value();
  //   return `<span>11111111111111111${formula}</span>`;
  // }
}
